import React from 'react';
import { Tooltip } from 'react-leaflet';
import { StyledSmallTooltipInner } from '../../Styled';
import { getValueSafely } from 'utils/utils';
import DefaultCell from 'components/DataTable/cells/DefaultCell';
import { Asset } from 'types/asset';

export default function SmallInfoBoxTooltip({ asset }: { asset: Asset }) {
  return (
    <Tooltip className="tooltip-small" opacity={1} direction="left" permanent offset={[-18, 0]}>
      <StyledSmallTooltipInner id={`asset-name-tooltip-${asset.asset_id}`}>
        <span>
          <DefaultCell value={asset.asset_type.name} />
        </span>
        <span>{getValueSafely(asset.asset_name)}</span>
      </StyledSmallTooltipInner>
    </Tooltip>
  );
}
